
import React from 'react';

export const BugIcon = () => (
  <img className="w-6 h-6" src="https://api.builder.io/api/v1/image/assets/TEMP/58531209611280f833c0f09e00b195f9d8063a65?width=49" alt="Bug report" />
);
